// E.g. /reports-dashboard/99556608/marketing -> reports-dashboard
// E.g. /contacts/99556608/deals -> deals
// E.g. /activity-feed/99569557 -> activity-feed

import getCurrentUrl from './getCurrentUrl';
export default function getCurrentApp() {
  const url = getCurrentUrl();
  const urlObject = new URL(url);
  const pathname = urlObject.pathname;
  if (pathname) {
    const splitPath = pathname.split('/');
    if (splitPath[1] === 'contacts' && splitPath.length > 2) {
      return splitPath[3] || null;
    } else {
      return splitPath[1] || null;
    }
  }
  return null;
}